module.exports = __webpack_public_path__ + "fonts/primeicons.d44157b.eot";